import { CalculatorId } from '../../../lib/calculators/calculator-config';
import type { CalculatorDescription } from '../../../lib/calculators/calculator-description';

export const coefficientDescription: CalculatorDescription = {
  id: CalculatorId.COEFFICIENT_OF_VARIATION,
  title: 'Coefficient of variation calculator',
  metaTitle: 'Online CV calculator - Relative standard deviation tool',
  description: 'Calculate the coefficient of variation to measure relative variability. Compare variation between datasets with different units or means.',
  metaDescription: 'Calculate coefficient of variation online. Measure relative variability with our free CV calculator. Compare variation across different datasets.',
  howTo: {
    title: 'How to use CV calculator',
    steps: [
      'Enter dataset values',
      'View mean and standard deviation',
      'Get CV result',
      'Compare multiple datasets',
      'Interpret results'
    ],
    graphic: {
      description: 'A data input form with calculated statistics display showing CV, mean, and standard deviation'
    }
  },
  examples: [
    {
      title: 'Investment returns',
      description: 'Analyzing investment portfolio volatility',
      dataDescription: 'Financial performance data across investments',
      insights: [
        'Shows relative volatility',
        'Compares risk levels',
        'Identifies consistency',
        'Measures return stability'
      ]
    },
    {
      title: 'Manufacturing quality',
      description: 'Analyzing production line consistency',
      dataDescription: 'Product measurements across batches',
      insights: [
        'Shows process consistency',
        'Compares production lines',
        'Identifies variation issues',
        'Monitors quality control'
      ]
    }
  ],
  relatedCalculators: [
    CalculatorId.STANDARD_DEVIATION,
    CalculatorId.MEAN,
    CalculatorId.VARIANCE
  ]
}; 